export default {
  'Submit': '送信',
  'Save': '保存',
  'enterOTP': '認証コードの入力',
  'otpSent': 'OTP 送信',
  'login/signup': 'ログイン / サインアップ',
  'resendCode': '再送コード',
  'edit': '編集',
  'otpMessage': 'お客様の携帯電話番号に6桁のコードが送信されました。',
  'oyo360WelcomeMessage': 'ログイン / サインアップ',
  'oyo360ResendCode': '再送コード',
  'oyo360Edit': '編集',
  'oyo360otpMessage': 'お客様の携帯電話番号に6桁のコードが送信されました。',
  'buttonActionContinue': '続ける',
  'chooseLanguage': '言語の選択',
  'currentLanguage': '現在の言語',
  'otherLanguages': '他の言語',
  'google': 'グーグル',
  'facebook': 'フェイスブック',
  'or': 'または',
  'buttonActionSubmit': '送信',
  'welcomeTitle': 'OYOへようこそ',
  'welcomeHeadingForMailLogin': '当社に登録されている電子メールアドレスを入力してください。',
  'welcomeHeadingForPhoneLogin': '当社に登録されている携帯電話番号を入力してください。',
  'emailIdLabel': 'メールアドレス',
  'phoneNumberLabel': '電話番号',
  'passwordLabel': 'パスワード',
  'newPasswordLabel': '新しいパスワード',
  'confirmNewPasswordLabel': '新パスワードの確認',
  'emailErrorMessage': '正しいEメールアドレスを入力してください。',
  'phoneNumberErrorMessage': '正しい電話番号を入力してください。',
  'passwordErrorMessage': '正しいパスワードを入力してください。',
  'confirmPasswordErrorMessage': 'パスワードが一致しません。',
  'generateNewPassword': '新しいパスワードの生成',
  'loginButtonLabel': 'ログイン',
  'loginWithPhoneButtonLabel': '電話を続ける',
  'loginWithOtp': 'OTPでのログイン',
  'loginWithEmailButtonLabel': '電子メールアドレスで続ける',
  'back': 'バック',
  'loginWithOtpTitle': '認証コードの入力',
  'loginWithOtpHeading': 'お客様の電話番号に6桁のコードが送信されました。',
  'listYourProperty': '物件を掲載する',
  'privacyPolicy': 'プライバシーポリシー',
  'verifyEmail': 'メールアドレスの確認',
  'verifyMobile': '携帯電話番号の確認',
  'forgotPasswordPhoneSubHeading': 'お客様の電話番号を確認するための6桁のコードをお送りします。',
  'forgotPasswordMailSubHeading': 'お客様のメールアドレスを確認するための6桁のコードをお送りします。',
  'newPasswordCondition1': '数字と記号の両方が必要',
  'newPasswordCondition2': '最低でも8人のキャラクターが必要',
  'newPasswordCondition3': '小文字と大文字の両方を持つべき',
  'confirmLogin': '確認・ログイン',
  'getOTP': 'OTPの取得',
  'invalidInput': '無効な入力',
  'passwordResetMessage': 'パスワード生成成功',
  'otpErrorMessage': '正しいワンタイムパスワードを入力してください。',
  'resendOtpSuccessMessage': 'OTPはあなたの携帯電話番号に再送されました。',
  'InternalServerErrorMessage': '内部サーバーエラー',
  'resetPasswordHeading': 'お客様のメールと電話番号に6桁のコードが送信されました。',
  'signingIn': 'サインイン',
  'invalidMobileNumber': '無効な携帯電話番号',
  'privacyFooterText': 'アカウントにログインすると、{termsOfUse}と{privacyPolicy}に同意したことになります。',
  'and': 'そして',
  'termsOfUse': '利用規約',
  'listProperty': '物件を掲載する',
  'whiteSpace': ' ',
  'errorNoAssociatedHotels': '\u95a2\u9023\u3059\u308b\u30db\u30c6\u30eb\u306f\u3042\u308a\u307e\u305b\u3093',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view'
};
